import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import { Input, Button, Box, Copy, Icon } from '@elparking/components'
import Select from 'commons/js/ui/Select'
import useApi from 'commons/js/hooks/useApi'
import { getConstant } from 'commons/js/constants'
import { getFineTowns } from 'commons/js/api'
import { Container } from '../ui'

const mesagges = defineMessages({
    bulletinNumerText: {
        defaultMessage: 'Número de boletín',
    },
    town: {
        defaultMessage: 'Ciudad',
    },
    noResults: {
        defaultMessage: 'No hay resultados',
    },
    placeholderTown: {
        defaultMessage: 'Selecciona la ciudad',
    },
    placeholderReportNumber: {
        defaultMessage: 'Número de boletín',
    },
})

const renderOptions = (elements) => elements.map(({name, id}) => ({
    value: id,
    label: name,
}))

const SelectLabel = ({ title }) =>
    <Copy padding='0' color='gray' transform='uppercase' fontWeight='medium' fontSize='xxxSmall'>
        {title}
    </Copy>

SelectLabel.propTypes = { title: PropTypes.string.isRequired }

const BulletinForm = ({ intl, onSearch, getFineTowns, brandId, townId }) => {
    const [bulletin, setBulletin] = useState()
    const [selectedCountry, setSelectedCountry] = useState(null)

    const {
        response: { result: towns, error },
        loading,
        sendRequest: getTowns,
    } = useApi(getFineTowns)

    useEffect(() => {
        getTowns({ countryId: getConstant('COUNTRY_ID'), brandId })
    }, [getTowns, brandId])

    useEffect(() => {
        if (towns) {
            const town = renderOptions(towns).find(({value}) => value === townId)
            setSelectedCountry(town)
        }
    }, [townId, towns])

    return (<Container key='form'>
        <Copy fontSize='xxLarge' fontWeight='book' >
            <FormattedMessage
              defaultMessage='Bienvenido al portal de reclamaciones'
            />
        </Copy>
        <Copy padding='2em 0' fontSize='small' fontWeight='regular' fontColor='gray80'>
            <FormattedMessage defaultMessage='Por favor, introduzca el número del boletín de su reclamación' />
        </Copy>
        <form data-test='form-bulletin' onSubmit={(event) => { event.preventDefault(); onSearch(bulletin, selectedCountry.value) }}>
            <Box pb='2em'>
                <SelectLabel title={intl.formatMessage(mesagges.town)} />
                <Select
                  height='40px'
                  options={towns && renderOptions(towns)}
                  disabled={loading}
                  showNativePlaceholder
                  clearable={false}
                  clearRenderer={() => null}
                  placeholder={intl.formatMessage(mesagges.placeholderTown)}
                  noResultsText={intl.formatMessage(mesagges.noResults)}
                  onChange={(option) => {
                    setBulletin(null)
                    setSelectedCountry(option)
                  }}
                  value={selectedCountry}
                />
                {
                    error && <Box>
                        <Copy padding='0px' mt='4px' color='red'>
                            <FormattedMessage defaultMessage='Error al recuperar el listado de ciudades' />
                        </Copy>
                    </Box>
                }
            </Box>
            <Box pb='2em'>
                <Input
                  disabled={!selectedCountry}
                  value={bulletin}
                  label={intl.formatMessage(mesagges.bulletinNumerText)}
                  placeholder={intl.formatMessage(mesagges.placeholderReportNumber)}
                  onChange={value => {
                    setBulletin(value)
                  }} />
            </Box>
            <Button type='submit' width='100%' disabled={!bulletin}>
                <FormattedMessage defaultMessage='Buscar denuncia' /> <Icon color='white' type='right' />
            </Button>
        </form>
    </Container>)
}

BulletinForm.propTypes = {
    intl: PropTypes.object.isRequired,
    onSearch: PropTypes.func.isRequired,
    getFineTowns: PropTypes.func.isRequired,
    brandId: PropTypes.number.isRequired,
    townId: PropTypes.number,
}

BulletinForm.defaultProps = {
    getFineTowns: getFineTowns,
}

export default injectIntl(BulletinForm)
